import axios from "axios";
export const LOCAL = axios.create({
    baseURL: "/tmp",
    headers: {
        "Content-Type": "application/json"
    }
});
export const CancelToken = axios.CancelToken;
export const HTTP = axios.create({
    baseURL: process.env.VUE_APP_API_URL + "/api",
    // headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded'
    // }
});
HTTP.interceptors.request.use(function (config) {
        if (!config.url) {
            return Promise.reject("Invalid Request Url");
        }
        var new_url = config.url;
        new_url = decodeURIComponent(new_url); // Required for URLs with '%20'
        new_url = new_url.replace(/^(\/)+|(\/)+$/g, ""); // Strip leading slashes && trailing slashes
        var new_params = config.params ? config.params : {};
        new_params["lang"] = localStorage.locale;

        // Do something before request is sent
        if (config.method == "get") {
            // if (process.env.NODE_ENV === "development" && !config._retry) { // For development only, load local cache file
            //     switch (new_url) {
            //         // case 'osc_variables':
            //         // case 'menu':
            //         // case 'footer':
            //         // case 'report':
            //         // case 'report/list/beneficiaries':
            //         // case 'public_upload/video':
            //         // case 'achievement':
            //         // case 'achievement/list':
            //         // case 'achievement/detail/184':
            //         // case 'home':
            //         // case 'news':
            //         // case 'events':
            //         // case 'beneficiaries':
            //         // case 'osc_grant':
            //         // case 'santa_public_upload':
            //         // case 'donation_box':
            //         // case 'activity/fiveaside':
            //         case 'donate/forms':
            //         // case 'proposal':
            //             // case 'proposal/edit/login':
            //             // case 'activity/fiveaside':
            //             // default: // TEMP: load local json
            //             for (var key in new_params) {
            //                 if (key == 'lang') {
            //                     new_url = new_params[key] + '/' + new_url;
            //                 } else {
            //                     new_url += '/' + new_params[key];
            //                 }
            //             }
            //             config.baseURL = '/tmp';
            //             config.url = new_url + '.json';
            //             config.params = null;
            //             config._retry = true;
            //             return config;
            //     }
            // }
            var parts = new_url.split("/");
            if (parts.length > 2 && parts[1] == "list" && parts[2] != "all") {
                new_params["type"] = parts[2];
                if (parts[3] != null) {
                    new_params["osc_year"] = parts[3];
                    parts.pop();
                }
                parts.pop();
                new_url = parts.join("/");
            }
        }
        config.url = new_url;
        config.params = new_params;
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    });
HTTP.interceptors.response.use((response) => {
    return response;
}, function (error) {
    let config = error.config;
    if (config) {
        if (config.method == "get" && process.env.NODE_ENV === "development" && !config._retry) {
            config._retry = true; // now it can be retried
            var new_url = config.url.replace(config.baseURL, "");
            var new_params = config.params ? config.params : {};
            for (var key in new_params) {
                if (key == "lang") {
                    if (!new_params[key]) {
                        new_params[key] = "en";
                    }
                    new_url = new_params[key] + new_url;
                } else {
                    new_url += "/" + new_params[key];
                }
            }
            return LOCAL.get(`${new_url}.json`, null).then((data) => {
                return data;
            }).catch((error) => {
                return Promise.reject(error);
            });
        }
    }
    return Promise.reject(error);
});